import { createRoot } from 'react-dom/client'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import App from '@App'
import { MuiTheme } from '@utils/muiTheme'
import reportWebVitals from '@reportWebVitals'
import './index.css'

// MuiTheme is defined with 'as const' which makes it readonly, but createTheme accepts mutable ThemeOptions
// The type augmentation in global.d.ts ensures compatibility
const theme = createTheme(MuiTheme as Parameters<typeof createTheme>[0])

const container = document.getElementById('rayze')

if (!container) {
  throw new Error('Failed to find the root element')
}

const root = createRoot(container)

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
